// 6to9, 9to12, 12to3, 3to6, 6to9p, Goal, Quote, Target, Success, Rewrite 
const entryTypes = {
    "Goal": {
        "name": "Goal",
        "plural": "Goals",
        "checkable": true,
    },
    "Quote": {
        "name": "Quote",
        "plural": "Quotes",
        "checkable": false,
    },
    "Target": {
        "name": "Target",
        "plural": "Targets",
        "checkable": true,
    },
    "Success": {
        "name": "Success",
        "plural": "Successes",
        "checkable": false,
    },
    "Rewrite": {
        "name": "Rewrite Goals",
        "plural": "Rewrite Goals",
        "checkable": false,
    },
    "6to9": {
        "name": "6to9",
        "plural": "6am - 9am",
        "checkable": true,
    },
    "9to12": {
        "name": "9to12",
        "plural": "9am to 12pm",
        "checkable": true,
    },
    "12to3": {
        "name": "12to3",
        "plural": "12pm to 3pm",
        "checkable": true,
    },
    "3to6": {
        "name": "3to6",
        "plural": "3pm to 6pm",
        "checkable": true,
    },
    "6to9p": {
        "name": "6to9p",
        "plural": "6pm to 9pm",
        "checkable": true,
    },
}

// Freemium: how many days of history the free plan can look back. Client-safe
// (imported by React components for upgrade prompts); the server-side
// enforcement lives in lib/authz.js.
const FREE_HISTORY_DAYS = 30;

export { entryTypes, FREE_HISTORY_DAYS };